import React from "react";

const IncrementIcon = () => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.673 6c1.11 0 1.5-.74.875-1.645L5.133.85c-.626-.907-1.644-.904-2.267 0L.45 4.356C-.176 5.265.215 6 1.326 6h5.347z"
        fill="#A3D9CB"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default IncrementIcon;
